(function () {
  var notifyHash = '#back-in-stock';
  var maxAttempts = 12;
  var attemptDelay = 250;

  function shouldOpenBackInStock() {
    var params = new URLSearchParams(window.location.search);
    return params.get('notify') === 'true' || window.location.hash === notifyHash;
  }

  function getBackInStockTarget() {
    return document.getElementById('back-in-stock') || document.querySelector('[data-back-in-stock]');
  }

  function isBackInStockVisible(target) {
    return Boolean(target) && !target.hasAttribute('hidden') && !target.classList.contains('lorenzos-back-in-stock-form--hidden');
  }

  function getProductSection(target) {
    return target ? target.closest('[data-section-type="product"]') : null;
  }

  function parseJsonElement(element) {
    if (!element) return null;

    try {
      return JSON.parse(element.textContent);
    } catch (error) {
      return null;
    }
  }

  function getVariantFromSection(section) {
    if (!section) return null;

    var variants = parseJsonElement(section.querySelector('[data-variant-json]'));
    if (!Array.isArray(variants) || !variants.length) return null;

    var selectedVariantId = section.querySelector('[data-product-select]') &&
      section.querySelector('[data-product-select]').value;
    if (selectedVariantId) {
      var selectedVariant = variants.find(function (variant) {
        return String(variant.id) === String(selectedVariantId);
      });

      if (selectedVariant) return selectedVariant;
    }

    var currentVariant = parseJsonElement(section.querySelector('[data-current-variant-json]'));
    if (currentVariant) return currentVariant;

    return variants[0];
  }

  function updateBackInStockFormVariant(target, variant) {
    if (!target) return;

    var variantIdInput = target.querySelector('[data-back-in-stock-variant-id-input]');
    if (variantIdInput) {
      variantIdInput.value = variant && variant.id ? variant.id : '';
    }

    var bodyInput = target.querySelector('[data-back-in-stock-body]');
    if (!bodyInput) return;

    var productUrl = target.getAttribute('data-back-in-stock-product-url') ||
      (window.location.origin + window.location.pathname);
    var bodyValue = 'Bitte benachrichtigen, sobald dieses Produkt wieder verfuegbar ist: ' + productUrl;

    if (variant) {
      bodyValue += ' | Variante: ' + (variant.title || '');
      bodyValue += ' | Variant-ID: ' + (variant.id || '');
    }

    bodyInput.value = bodyValue;
  }

  function setBackInStockVisibility(target, variant) {
    if (!target) return;

    var shouldShow = Boolean(variant && variant.available === false);
    target.toggleAttribute('hidden', !shouldShow);
    target.setAttribute('aria-hidden', shouldShow ? 'false' : 'true');
    target.classList.toggle('lorenzos-back-in-stock-form--hidden', !shouldShow);
    updateBackInStockFormVariant(target, variant);
  }

  function initBackInStockVisibility(root) {
    var scope = root || document;

    scope.querySelectorAll('[data-back-in-stock]').forEach(function (target) {
      var section = getProductSection(target);
      setBackInStockVisibility(target, getVariantFromSection(section));

      if (section && !section.dataset.lorenzosBackInStockBound) {
        section.dataset.lorenzosBackInStockBound = 'true';
        section.addEventListener('variantChange', function (event) {
          section.querySelectorAll('[data-back-in-stock]').forEach(function (sectionTarget) {
            setBackInStockVisibility(sectionTarget, event.detail && event.detail.variant);
            if (shouldOpenBackInStock() && isBackInStockVisible(sectionTarget)) {
              openBackInStock(sectionTarget);
            }
          });
        });
      }
    });
  }

  function isDesktopViewport() {
    return window.matchMedia('(min-width: 769px)').matches;
  }

  function focusEmailField(target) {
    if (!isDesktopViewport()) return;

    var emailField = target.querySelector('[data-back-in-stock-email], input[type="email"], input[name="contact[email]"]');
    if (!emailField) return;

    setTimeout(function () {
      emailField.focus({ preventScroll: true });
    }, 180);
  }

  function openCollapsible(target) {
    var trigger = target.querySelector('[data-back-in-stock-trigger], .collapsible-trigger[aria-controls]');
    if (!trigger) return;

    var isOpen = trigger.classList.contains('is-open') || trigger.getAttribute('aria-expanded') === 'true';
    if (!isOpen) {
      trigger.click();
    }
  }

  function openBackInStock(target) {
    openCollapsible(target);

    setTimeout(function () {
      target.scrollIntoView({ behavior: 'smooth', block: 'center' });
      focusEmailField(target);
    }, 120);
  }

  function tryOpenBackInStock(attempt) {
    if (!shouldOpenBackInStock()) return;

    var target = getBackInStockTarget();
    if (isBackInStockVisible(target)) {
      openBackInStock(target);
      return;
    }

    if (attempt < maxAttempts) {
      setTimeout(function () {
        tryOpenBackInStock(attempt + 1);
      }, attemptDelay);
    }
  }

  function handleBackInStockClick(event) {
    var link = event.target.closest('.lorenzos-product-back-in-stock-link, a[href="#back-in-stock"]');
    if (!link) return;

    var target = getBackInStockTarget();
    if (!target) return;

    event.preventDefault();
    if (!isBackInStockVisible(target)) return;

    if (window.location.hash !== notifyHash) {
      history.replaceState(null, '', notifyHash);
    }
    openBackInStock(target);
  }

  function getStoryMaxHeight() {
    return window.matchMedia('(max-width: 768px)').matches ? 360 : 560;
  }

  function getStoryToggleLabel(toggle, isExpanded) {
    return toggle.getAttribute(isExpanded ? 'data-expanded-label' : 'data-collapsed-label') ||
      (isExpanded ? 'Weniger anzeigen' : 'Mehr ueber dieses Produkt erfahren');
  }

  function getToggleLabel(toggle, isExpanded, collapsedFallback) {
    return toggle.getAttribute(isExpanded ? 'data-expanded-label' : 'data-collapsed-label') ||
      (isExpanded ? 'Weniger anzeigen' : collapsedFallback);
  }

  function updateStoryCollapse(story) {
    var content = story.querySelector('.feature-row__text .rte');
    var toggle = story.querySelector('[data-lorenzos-story-toggle]');
    if (!content || !toggle) return;

    var isExpanded = story.classList.contains('is-expanded');

    story.classList.remove('has-story-collapse');
    story.style.removeProperty('--lorenzos-story-max-height');
    toggle.hidden = true;

    window.requestAnimationFrame(function () {
      var maxHeight = getStoryMaxHeight();
      var shouldCollapse = content.scrollHeight > maxHeight + 28;

      if (!shouldCollapse) {
        story.classList.remove('is-expanded');
        toggle.setAttribute('aria-expanded', 'false');
        return;
      }

      story.style.setProperty('--lorenzos-story-max-height', maxHeight + 'px');
      story.classList.add('has-story-collapse');
      toggle.hidden = false;
      toggle.setAttribute('aria-expanded', isExpanded ? 'true' : 'false');
      toggle.textContent = getStoryToggleLabel(toggle, isExpanded);
    });
  }

  function initStoryCollapse(root) {
    var scope = root || document;
    scope.querySelectorAll('[data-lorenzos-story-candidate]').forEach(updateStoryCollapse);
  }

  function handleStoryToggle(event) {
    var toggle = event.target.closest('[data-lorenzos-story-toggle]');
    if (!toggle) return;

    var story = toggle.closest('[data-lorenzos-story-candidate]');
    if (!story) return;

    var isExpanded = !story.classList.contains('is-expanded');
    story.classList.toggle('is-expanded', isExpanded);
    toggle.setAttribute('aria-expanded', isExpanded ? 'true' : 'false');
    toggle.textContent = getStoryToggleLabel(toggle, isExpanded);

    if (!isExpanded) {
      story.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
    }
  }

  function getDescriptionMaxHeight() {
    if (!window.matchMedia('(max-width: 768px)').matches) return null;
    return 340;
  }

  function updateDescriptionCollapse(wrapper) {
    var content = wrapper.querySelector('.lorenzos-product-description__content');
    var toggle = wrapper.querySelector('[data-lorenzos-description-toggle]');
    if (!content || !toggle) return;

    var isExpanded = wrapper.classList.contains('is-expanded');

    wrapper.classList.remove('has-description-collapse');
    wrapper.style.removeProperty('--lorenzos-description-max-height');
    toggle.hidden = true;

    var maxHeight = getDescriptionMaxHeight();

    if (maxHeight === null) {
      wrapper.classList.remove('is-expanded');
      toggle.setAttribute('aria-expanded', 'false');
      return;
    }

    window.requestAnimationFrame(function () {
      var shouldCollapse = content.scrollHeight > maxHeight + 36;

      if (!shouldCollapse) {
        wrapper.classList.remove('is-expanded');
        toggle.setAttribute('aria-expanded', 'false');
        return;
      }

      wrapper.style.setProperty('--lorenzos-description-max-height', maxHeight + 'px');
      wrapper.classList.add('has-description-collapse');
      toggle.hidden = false;
      toggle.setAttribute('aria-expanded', isExpanded ? 'true' : 'false');
      toggle.textContent = getToggleLabel(toggle, isExpanded, 'Mehr zur Produktbeschreibung');
    });
  }

  function initDescriptionCollapse(root) {
    var scope = root || document;
    scope.querySelectorAll('[data-lorenzos-description-candidate]').forEach(updateDescriptionCollapse);
  }

  function handleDescriptionToggle(event) {
    var toggle = event.target.closest('[data-lorenzos-description-toggle]');
    if (!toggle) return;

    var wrapper = toggle.closest('[data-lorenzos-description-candidate]');
    if (!wrapper) return;

    var isExpanded = !wrapper.classList.contains('is-expanded');
    wrapper.classList.toggle('is-expanded', isExpanded);
    toggle.setAttribute('aria-expanded', isExpanded ? 'true' : 'false');
    toggle.textContent = getToggleLabel(toggle, isExpanded, 'Mehr zur Produktbeschreibung');

    if (!isExpanded) {
      wrapper.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
    }
  }


  /* Lorenzos JudgeMe real swipe fix */
  function findJudgeMeReviewContainer(review) {
    if (!review) return null;

    var candidates = [
      '.jdgm-rev-widg__reviews',
      '.jdgm-rev-widg__body',
      '.jdgm-all-reviews__body',
      '.jdgm-widget',
      '.jdgm-rev-widg',
      '[class*="jdgm"]'
    ];

    for (var i = 0; i < candidates.length; i += 1) {
      var container = review.closest(candidates[i]);
      if (container && container.querySelectorAll('.jdgm-rev').length > 1) {
        return container;
      }
    }

    return review.parentElement;
  }

  function initJudgeMeSwipeReviews() {
    if (!window.matchMedia('(max-width: 768px)').matches) return;

    var reviews = Array.prototype.slice.call(document.querySelectorAll('.jdgm-rev'));
    if (!reviews.length) return;

    var containers = [];
    reviews.forEach(function (review) {
      var container = findJudgeMeReviewContainer(review);
      if (!container || containers.indexOf(container) !== -1) return;
      if (container.querySelectorAll('.jdgm-rev').length < 2) return;
      containers.push(container);
    });

    containers.forEach(function (container) {
      container.classList.add('lorenzos-judgeme-swipe-track');
      container.setAttribute('data-lorenzos-judgeme-swipe', 'true');

      Array.prototype.slice.call(container.querySelectorAll('.jdgm-rev')).forEach(function (review, index) {
        review.classList.add('lorenzos-judgeme-swipe-card');
        review.setAttribute('data-lorenzos-review-index', String(index + 1));
      });

      var widget = container.closest('.jdgm-widget, .jdgm-rev-widg, .jdgm-all-reviews-widget');
      if (widget) {
        widget.classList.add('lorenzos-judgeme-swipe-widget');
      }
    });
  }

  function scheduleJudgeMeSwipeReviews() {
    var delays = [120, 350, 800, 1400, 2400, 3800, 5500];
    delays.forEach(function (delay) {
      setTimeout(initJudgeMeSwipeReviews, delay);
    });
  }
  document.addEventListener('DOMContentLoaded', function () {
    initBackInStockVisibility(document);
    initStoryCollapse(document);
    initDescriptionCollapse(document);
    scheduleJudgeMeSwipeReviews();

    setTimeout(function () {
      tryOpenBackInStock(0);
    }, 180);
  });

  document.addEventListener('page:loaded', function () {
    initBackInStockVisibility(document);
    initStoryCollapse(document);
    initDescriptionCollapse(document);
    scheduleJudgeMeSwipeReviews();
    tryOpenBackInStock(0);
  });

  document.addEventListener('shopify:section:load', function (event) {
    initBackInStockVisibility(event.target);
    initStoryCollapse(event.target);
    initDescriptionCollapse(event.target);
    scheduleJudgeMeSwipeReviews();
  });

  window.addEventListener('hashchange', function () {
    tryOpenBackInStock(0);
  });

  var storyResizeTimer;
  window.addEventListener('resize', function () {
    clearTimeout(storyResizeTimer);
    storyResizeTimer = setTimeout(function () {
      initStoryCollapse(document);
      initDescriptionCollapse(document);
      initJudgeMeSwipeReviews();
    }, 160);
  });

  document.addEventListener('click', handleBackInStockClick);
  document.addEventListener('click', handleStoryToggle);
  document.addEventListener('click', handleDescriptionToggle);
})();
